// Silences console output on the production domain only.
// Test (test.blends.co.il), staging and localhost keep full logs — exact
// hostname match matters here since 'test.blends.co.il' contains 'blends.co.il'.
// Escape hatch for debugging live prod: localStorage.setItem('blends_debug', '1')
const PROD_HOSTS = ['blends.co.il', 'www.blends.co.il'];

const isProdHost =
  typeof window !== 'undefined' && PROD_HOSTS.includes(window.location.hostname);

const debugOverride = (() => {
  try {
    return window.localStorage.getItem('blends_debug') === '1';
  } catch (e) {
    return false;
  }
})();

if (isProdHost && !debugOverride) {
  const noop = () => {};
  ['log', 'info', 'debug', 'warn', 'trace', 'table', 'group', 'groupCollapsed', 'groupEnd'].forEach(
    (method) => {
      // eslint-disable-next-line no-console
      console[method] = noop;
    }
  );
}
